import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import ConfigContext from '../../contexts/ConfigContext';

// Components
import Meta from '../shared/Meta';

function ChooseAccount() {
  const { vehicle_type, city_name } = useContext(ConfigContext);

  return (
    <div className='Section u-textCenter'>
      <Meta noindex />

      <h1 className='u-mb2'>Sign Up</h1>

      <div className='Box u-p2 Box--white'>
        <h3 className='u-mb1'>
          I&#39;m a Food {vehicle_type} Vendor
        </h3>
        <p className='u-limitWidth20 u-blockCenter'>
          Join {city_name}&#39;s food {vehicle_type.toLowerCase()} community of over 300 mobile vendors and growing!
        </p>
        <Link
          className='Button'
          to='/vendors'
        >
          Sign up as a Vendor
        </Link>
      </div>

      <h3 className='u-color-grey u-upperCase u-mt1 u-mb1'>or</h3>

      <div className='Box u-p2 Box--white'>
        <h3 className='u-mb1'>
          I Want to Book a {vehicle_type}
        </h3>
        <p className='u-limitWidth20 u-blockCenter'>
          Hire and compare prices on {city_name}&#39;s best food {vehicle_type.toLowerCase()}s for your next event!
        </p>
        <Link
          className='Button'
          to='catering/register'
        >
          Sign up to book {vehicle_type.toLowerCase()}s
        </Link>
      </div>

      <div className='u-textCenter'>
        <hr className='u-mb3 u-mt3' />
        <h3 className='u-mb1'>Already Have an Account?</h3>
        <Link
          to='/login'
          className='Button'
        >
          Log In
        </Link>
      </div>
    </div>
  );
}

export default ChooseAccount;
